import { useQpmCatalogListQuery } from "@/services/backend/qpm/catalog/api/catalog-api";
import { Button } from "@/shared/components/ui/button";
import t from "@/lang/lang";
import {
  useQpmBootstrapUpdateBaseDataMutation,
  useQpmBootstrapUpdateMonitorsMutation,
} from "@/services/backend/qpm/bootstrap/api/bootstrap-api";
import { parseRTKQueryError } from "@/shared/components/errors/parse-r-t-k-query-error";
import { useToast } from "@/shared/hooks/use-toast";
import { useActiveCompany } from "@/shared/lib/active-company/active-company-provider";

export function SeedIfEmpty() {
  const { toast } = useToast();
  const { companyId } = useActiveCompany();
  const {
    data: list,
    error,
    isLoading,
  } = useQpmCatalogListQuery({
    company: { active: true, values: [companyId] },
  });

  const [updateBaseData, { isLoading: isUpdatingBaseData }] =
    useQpmBootstrapUpdateBaseDataMutation();
  const [updateMonitors, { isLoading: isUpdatingMonitors }] =
    useQpmBootstrapUpdateMonitorsMutation();

  if (isLoading || error || !list || !list.items || list.items.length > 0) {
    return null;
  }

  const isSeeding = isUpdatingBaseData || isUpdatingMonitors;
  const onInitialize = async () => {
    try {
      await updateMonitors({}).unwrap();
      await updateBaseData({}).unwrap();
    } catch (err) {
      const parsedError = parseRTKQueryError(
        err as Parameters<typeof parseRTKQueryError>[0],
      );
      if (parsedError) {
        toast({
          title: parsedError.title,
          description: parsedError.description,
        });
      }
    }
  };

  if (list && list.items.length === 0) {
    return (
      <Button variant="outline" onClick={onInitialize} disabled={isSeeding}>
        {t("Stammdaten initialisieren")}
      </Button>
    );
  }
}
